import React from "react";
import { useNavigate } from "react-router-dom";

const Error = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="err-page">
        <div className="err-blog" 
        style={{backgroundImage: "url(error.jpg)", backgroundSize: "cover", backgroundPosition: "center center", backgroundRepeat: "no-repeat", width: "100%"}}>
          <h1 className="err-header">Error Page ..!!</h1>
          <p className="err-para">
            sorry page not found, try something else or back to home page.
          </p>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => navigate("/", { replace: true })}
          >
            Home Page
          </button>
        </div>
      </div>
    </>
  );
};
export default Error;
